import React from 'react';
import { connect } from 'react-redux';
import CardPaiementCheque from './CardPaiementCheque';
import CardPaiementVirement from './CardPaiementVirement';
import CardPaiementPrlManuel from './CardPaiementPrlManuel';
import CardChoixModePaiement from './CardChoixModePaiement';
import CardPrelevement from '../Prelevement/CardPrelevement';
import CardAutrePaiement from './CardAutrePaiement';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';


const CardModePaiement = ({
    Mandat, setChoix, choixModePaiement, setAutreChoix, SoldeAPayer, autreModePaiement, SoldeAPrl, setSoldeAPrl, history,
}) => {
    if (!Mandat.PrlOk) {
        switch (choixModePaiement) {
        case 'virement':
            return <CardPaiementVirement setChoix={setChoix} />;
        case 'cheque':
            return <CardPaiementCheque setChoix={setChoix} />;
        default:
            return <CardChoixModePaiement setChoix={setChoix} />;
        }
    } else {
        switch (Mandat.ModePrl) {
        case 1:
        case 2:
            return (
                <React.Fragment>
                    <CardPrelevement PagePaiement />
                    <CardAutrePaiement setChoix={setAutreChoix} choixModePaiement={autreModePaiement} />
                </React.Fragment>
            );
        case 3:
            return (
                <React.Fragment>
                    <CardPaiementPrlManuel SoldeAPayer={SoldeAPayer} SoldeAPrl={SoldeAPrl} setSoldeAPrl={setSoldeAPrl} history={history} />
                    <CardAutrePaiement setChoix={setAutreChoix} choixModePaiement={autreModePaiement} Manuel />
                </React.Fragment>
            );
        default:
            return (<div classNae="alert alert-warning" role="alert"><h4 className="alert-heading">Message d&apos;erreur</h4>Le moyen de paiement choisi n&apos;est pas défini</div>);
        }
    }
};

CardModePaiement.displayName = 'CardModePaiement';
CardModePaiement.requiredProps = [
    'Mandat', // Mandat du pro
];

function mapStateToProps({
    ProStore: {
        Pro: { Mandat },
    },
}) {
    return { Mandat };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardModePaiement));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Paiement/CardModePaiement.js